gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);
gsap.registerPlugin(MotionPathPlugin);
gsap.registerPlugin(CustomEase);

let mm = gsap.matchMedia();

const pageInEasing = CustomEase.create('pageInEasing', '0.8, 0.0, 0.2, 1.0');
const opacityInEasing = CustomEase.create('opacityInEasing', '0.0, 0.0, 0.1, 0.1');
const inEasing = CustomEase.create('inEasing', '0.2, 0, 0.2, 1');
const heroDescriptorInEasing = CustomEase.create('heroDescriptorInEasing', '0.4, 0, 0.2, 1');
const tagInEasing = CustomEase.create('tagInEasing', '0.6, 0, 0.2, 1');

gsap.config({
  force3D: true,
});
